import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocalisation } from '@3plearning/lingui-cdn';
import orderBy from 'lodash/orderBy';

import PulseLoader from '@components/pulse-loader';
import Checkbox from '@components/checkbox';
import { CHECKED, UNCHECKED } from '@components/checkbox/constants';
import SvgIcon from '@components/svg-icon/svg-icon';
import { DownArrow, UpArrow } from '@helpers/icon-dictionary';
import DueDateInfo from './assignment/components/due-date-info/due-date-info'
import NoDataView from '../no-data-view';
import {
  SELECT_ALL_ASSIGNMENTS,
  UNSELECT_ALL_ASSIGNMENTS,
  UPDATE_SORT_DIRECTION_TO_ASC,
  UPDATE_SORT_DIRECTION_TO_DESC
} from '../redux/actions';

import Assignment from './assignment';
import {
  Body,
  CheckboxWrapper,
  Header,
  HeaderTitle,
  IconContainer,
  LoaderContainer,
  Root,
  SortableHeader
} from './styled';

const AssignedList = () => {
  const { i18n } = useLocalisation();
  const dispatch = useDispatch();

  const assignments = useSelector(state => state.currentAssignmentsModalReducer.assignments);
  const loading = useSelector(state => state.currentAssignmentsModalReducer.loading);
  const sortDirection = useSelector(state => state.currentAssignmentsModalReducer.sortDirection);
  const selectedAssignmentIds = useSelector(state => state.currentAssignmentsModalReducer.selectedAssignmentIds);

  const sortedAssignments = orderBy(assignments, 'learningJourneyName', sortDirection);
  const arrowIcon = sortDirection === 'asc' ? DownArrow : UpArrow;
  const assignmentsCount = assignments.length;
  const isSelectedAll = assignmentsCount > 0 && selectedAssignmentIds.length === assignmentsCount;

  const updateSortDirection = () => {
    dispatch({ type: sortDirection === 'asc' ? UPDATE_SORT_DIRECTION_TO_DESC : UPDATE_SORT_DIRECTION_TO_ASC });
  };

  const handleSelectAll = () => {
    dispatch({ type: isSelectedAll ? UNSELECT_ALL_ASSIGNMENTS : SELECT_ALL_ASSIGNMENTS });
  };
  return (
    <Root>
      <Header>
        <CheckboxWrapper>
          <Checkbox checkboxHandler={handleSelectAll} state={isSelectedAll ? CHECKED : UNCHECKED} />
        </CheckboxWrapper>

        <SortableHeader onClick={updateSortDirection}>
          {i18n.t`Skill Quest`}
          <IconContainer>
            <SvgIcon icon={arrowIcon} />
          </IconContainer>
        </SortableHeader>

        <HeaderTitle width="35%">{i18n.t`Course`}</HeaderTitle>
        <HeaderTitle>{i18n.t`Accuracy`}</HeaderTitle>
        <HeaderTitle>{i18n.t`Progress`}</HeaderTitle>
        <HeaderTitle>{i18n.t`Assigned`}</HeaderTitle>
        <HeaderTitle>{i18n.t`DueDate`}
          <DueDateInfo />
        </HeaderTitle>
      </Header>

      {loading && (
        <LoaderContainer>
          <PulseLoader />
        </LoaderContainer>
      )}

      {!loading && assignmentsCount === 0 && (
        <LoaderContainer>
          <NoDataView />
        </LoaderContainer>
      )}
	
      {!loading && assignmentsCount > 0 && (
        <Body>
          {sortedAssignments.map(assignment => (
            <Assignment key={assignment.assignmentId} assignment={assignment} />
          ))}
        </Body>
      )}
    </Root>
  );
};

export default AssignedList;
